// Utilities
import { defineStore } from 'pinia'
import API from '@/api/api'

export const useRadioStore = defineStore('radio', {
  state: () => ({
    stations       : [],
    lastUpdate     : null,
    selectedStation: null,
    isLoading      : false
  }),

  getters: {},

  actions: {
    getByCountry (useCache = true) {
      if (useCache) {
        const now = Date.now()
        const difference = now - (this.lastUpdate || 0)
        const hoursDifference = Math.floor(difference / 1000 / 60 / 60)
        const minutesDifference = Math.floor(difference / 1000 / 60)

        if (this.stations.length > 0 && hoursDifference <= 6 && minutesDifference > 0) {
          return
        }
      }

      this.isLoading = true

      return API.endpoint.radio.getByCountry('greece')
        .then(response => {
          this.stations = response.data
          this.lastUpdate = Date.now()
        })
        .catch(error => {})
        .finally(() => {
          this.isLoading = false
        })
    }
  },

  persist: {
    storage: localStorage,
    pick   : undefined,
    omit   : undefined
  }
})
